// src/context/ThemeContext.js

import PropTypes from "prop-types";
import React, { createContext, useState, useContext } from "react";

const ThemeContext = createContext();

export const Theme = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  const toggleTheme = () => setDarkMode((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

Theme.propTypes = {
    children: PropTypes.node.isRequired,
  };

export const useTheme = () => useContext(ThemeContext);
